module.exports = __webpack_public_path__ + "img/Guirlande_led.35f9965.jpg";